import { NgModule } from '@angular/core';
import { PromoStoreModule } from './store';

@NgModule({
  imports: [PromoStoreModule],
})
export class PromoDataAccessModule {}
